if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.form.addEventListener('submit', this.onSubmitPreHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    // ========================================================================
    // Before default onsubmit handler, check if conversion kit to show modal
    // ========================================================================
    onSubmitPreHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (document.body.classList.contains('template-product-conversion-kit') && this.form.getAttribute('id').includes('product-form-template')) {
        const modal = document.getElementById('PopupModal-confirm');

        if (modal) {
          modal.show();

          let selectLocation = modal.querySelector('select');
          let buttonConfirm = modal.querySelector('#buttonConfirm');
          let inputLocation = document.createElement('input');
          inputLocation.setAttribute('type', 'hidden');
          inputLocation.setAttribute('name', 'properties[Pickup location]');

          selectLocation.addEventListener('change', () => {
            buttonConfirm.removeAttribute('disabled');
          });

          buttonConfirm.addEventListener('click', () => {
            inputLocation.setAttribute('value', selectLocation.value);
            this.form.append(inputLocation);
            this.onSubmitHandler(evt);
            modal.hide();
          });
        }

        // ==============================================================
        // CUSTOM - Handle adding core addon products to form
        // ==============================================================

        // <input type="hidden" name="items[1][quantity]" value="1">
        // <input type="hidden" name="items[1][id]" value="43120544776360">
        let coreAddonProducts = this.closest('product-info').querySelectorAll('.kit-addon-products-wrap input[value="purchase"]:checked');

        let coreAddonNum = 1;
        for (let addonProduct of coreAddonProducts) {
  
            let addonId = addonProduct.dataset.addonId;
  
            let inputAddonQuantity = document.createElement('input');
            inputAddonQuantity.setAttribute('type', 'hidden')
            inputAddonQuantity.setAttribute('name', `items[${coreAddonNum}][quantity]`)
            inputAddonQuantity.setAttribute('value', '1');
            
            let inputAddonId = document.createElement('input');
            inputAddonId.setAttribute('type', 'hidden')
            inputAddonId.setAttribute('name', `items[${coreAddonNum}][id]`)
            inputAddonId.setAttribute('value', addonId);
            
            this.form.prepend(inputAddonQuantity, inputAddonId);
  
          coreAddonNum++;
        }        
        
      } else {
        this.onSubmitHandler(evt);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
